import { render } from "./VenueEventList.vue?vue&type=template&id=98eca90e&scoped=true"
import script from "./VenueEventList.vue?vue&type=script&lang=js"
export * from "./VenueEventList.vue?vue&type=script&lang=js"

import "./VenueEventList.vue?vue&type=style&index=0&id=98eca90e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98eca90e"]])

export default __exports__